import { onInitService } from "./init-service";

export { useRequest } from "./hooks/use-request";
export { useGet } from "./hooks/use-get";
export { useDelete } from "./hooks/use-delete";
export { usePost } from "./hooks/use-post";
export { usePut } from "./hooks/use-put";
export { useQuery } from "./hooks/use-query";
export { useMutation } from "./hooks/use-mutation";

export const serviceRest = [
  {
    target: "$INIT_SERVICE",
    handler: onInitService
  }
];
